var map = {
	"./about-us/_index.scss": 6274,
	"./block-2-general-emenities/_index.scss": 8061,
	"./contact/_index.scss": 4586,
	"./content-image/_index.scss": 8733,
	"./detail-hero/_index.scss": 5282,
	"./details/_index.scss": 2252,
	"./events-samples/_index.scss": 2871,
	"./gallery/_index.scss": 8112,
	"./hero/_index.scss": 6858,
	"./list-cards/_index.scss": 2284,
	"./map/_index.scss": 5496,
	"./our-partners/_index.scss": 8264,
	"./our-pricing/_index.scss": 6253,
	"./our-service/_index.scss": 5726,
	"./our-spaces/_index.scss": 6976,
	"./review/_index.scss": 2978,
	"./seo-block/_index.scss": 8081,
	"./simple-text/_index.scss": 6468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6415;